import { useParams } from 'react-router';

import { getCountryLanguage } from '@repo/utils';

import { getAppConfig } from '@/utils/window.utils.ts';

const { country, language } = getCountryLanguage();

export const useAppBaseUrl = () => {
    const params = useParams();

    const urlSuffix = typeof import.meta.env.VITE_URL_SUFFIX === 'string' && params[import.meta.env.VITE_URL_SUFFIX];

    return `/${country}/${language}/orders${urlSuffix ? `/${urlSuffix}` : ''}`;
};

export const navigateToCartHome = () => {
    const { cartDomain, cartHomePath } = getAppConfig();

    const cartBaseUrl = `${cartDomain}/${country}/${language}/${cartHomePath}`;

    globalThis.location.href = cartBaseUrl;
};
